import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@tolgee/ngx';
import { toast, ToastT } from 'ngx-sonner';
import { ErrorStatus, ServerErrorCodes, ServerErrorCodesType } from '../../errors';
import { ToastService } from '../../services';
import { RequestModel } from '../models';

type RequestData = Pick<
  RequestModel,
  'successMessage' | 'shouldIndicateLoader' | 'errorMessage' | 'skipNotify' | 'redirectOnError'
>;

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  translateService = inject(TranslateService);
  constructor(
    private readonly toastService: ToastService,
    private readonly modalService: NgbModal,
    private readonly router: Router,
  ) {}

  success(message: string, title?: string) {
    toast.success(title || message, {
      description: title ? message : undefined,
    });
    // this.toastService.show(message, title, {
    //   classname: 'success',
    //   autoHide: true,
    //   delay: 5000,
    // });
  }

  info(message: string, title?: string) {
    toast.info(title || message, {
      description: title ? message : undefined,
    });
  }

  warning(message: string, title?: string) {
    toast.warning(title || message, {
      description: title ? message : undefined,
    });
    // this.toastService.show(message, title, {
    //   classname: 'warning',
    //   autoHide: true,
    //   delay: 5000,
    // });
  }

  error(message: string, title?: string) {
    toast.error(title || message, {
      description: title ? message : undefined,
    });
    // this.toastService.show(message, title, {
    //   classname: 'danger',
    //   autoHide: true,
    //   delay: 5000,
    // });
  }

  action(message: string, title?: string, actionSettings?: ToastT['action'], autoHide = true) {
    toast.info(title || message, {
      description: title ? message : undefined,
      action: actionSettings,
      duration: autoHide ? 5000 : Infinity,
      position: 'top-right',
      dismissible: autoHide,
    });
  }

  handleServerError(error: HttpErrorResponse, data: RequestData) {
    if (data.errorMessage) {
      return;
    }
    if (data.redirectOnError) {
      const errorList: { message: string; code: ServerErrorCodesType }[] = error.error?.errors;
      switch (error.status) {
        case 404:
          if (!data.skipNotify) {
            this.error(this.translateService.instant('error.notFound'), '404');
          }
          if (data.redirectOnError !== 'none') {
            this.modalService.dismissAll();
            void this.router.navigate([data.redirectOnError], {
              queryParams: { params: JSON.stringify(error.error) },
            });
          } else {
            void this.router.navigate(['/dashboard']);
          }
          break;

        case 400:
          if (errorList.some((e) => e.code === ServerErrorCodes.LOCKED_GROUP)) {
            void this.router.navigate([`/error/${ErrorStatus.GroupLocked}`]);
          }
          break;
      }
    } else {
      if (error.status === 404 && !data.skipNotify) {
        this.error(this.translateService.instant('error.notFound'), '404');
      }
    }
  }
}
